module.exports = "/_next/static/images/019cfb969e712e208340eb972b969696-pj-man-in-denim-jacket@xs.jpg.webp";